export default __webpack_public_path__ + "static/media/WiFi_UID_ti40039.6dfa9e19.png";